import React from 'react';
import { Eye } from 'lucide-react';

interface ReadOnlyAccessNoticeProps {
  message: string;
}

export const ReadOnlyAccessNotice: React.FC<ReadOnlyAccessNoticeProps> = ({
  message,
}) => (
  <div className="app-bg flex items-start gap-3 rounded-xl border border-emerald-100 px-4 py-3 text-sm text-black/75">
    <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white text-emerald-600 shadow-sm">
      <Eye size={16} />
    </div>
    <p className="leading-6">{message}</p>
  </div>
);
